"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TxnExpireText = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("@chakra-ui/react");
function TxnExpireText({ hours, minutes, seconds, }) {
    return ((0, jsx_runtime_1.jsxs)(react_1.HStack, { children: [hours ? ((0, jsx_runtime_1.jsxs)(react_1.Text, Object.assign({ as: "span", fontWeight: "medium" }, { children: [hours, "h"] }))) : null, minutes ? ((0, jsx_runtime_1.jsxs)(react_1.Text, Object.assign({ as: "span", fontWeight: "medium" }, { children: [minutes, "m"] }))) : null, seconds ? ((0, jsx_runtime_1.jsxs)(react_1.Text, Object.assign({ as: "span", fontWeight: "medium" }, { children: [seconds, "s"] }))) : null] }));
}
exports.TxnExpireText = TxnExpireText;
